import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingProgressOverlay = ({ loadingProgress, loading }) => {
  // Don't show if not loading or no progress info
  if (!loading && loadingProgress.phase === 'idle') {
    return null;
  }

  const { phase, percentage, message, processedRows, fileSize } = loadingProgress;

  // Show determinate progress bar if we have useful progress info
  const showProgressBar = phase === 'parsing' && (percentage > 0 || processedRows > 0);

  return (
    <Box sx={{
      position: 'absolute',
      top: 0, 
      left: 0, 
      width: '100%', 
      height: '100%',
      bgcolor: 'background.default',
      opacity: 0.95,
      zIndex: 25,
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      backdropFilter: 'blur(2px)'
    }}>
      <Box sx={{
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        p: 4,
        minWidth: 320,
        maxWidth: 420,
        boxShadow: 2,
        textAlign: 'center'
      }}>
        {/* Main loading message */}
        <Typography variant="h6" sx={{ fontWeight: 500, mb: 2 }}>
          {message || 'Loading...'}
        </Typography>

        {/* Progress indicator */}
        {showProgressBar ? (
          <Box mb={1}>
            <LinearProgress 
              variant={percentage > 0 ? "determinate" : "indeterminate"}
              value={percentage} 
              sx={{ height: 6, borderRadius: 1, mb: 1 }}
            />
            <Typography variant="body2" color="text.secondary">
              {percentage > 0 
                ? `${percentage}% complete`
                : processedRows > 0 
                  ? `${processedRows.toLocaleString()} events parsed`
                  : 'Starting...'}
            </Typography>
          </Box>
        ) : (
          <Box>
            <CircularProgress size={32} />
            {phase === 'downloading' && fileSize > 0 && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {(fileSize / 1024 / 1024).toFixed(1)} MB
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default LoadingProgressOverlay;
